import { render, staticRenderFns } from "./GameHits.vue?vue&type=template&id=16dd5830&scoped=true"
import script from "./GameHits.vue?vue&type=script&lang=js"
export * from "./GameHits.vue?vue&type=script&lang=js"
import style0 from "./GameHits.vue?vue&type=style&index=0&id=16dd5830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dd5830",
  null
  
)

export default component.exports